module.exports = __webpack_public_path__ + "static/about-us-model-photo-ac891c90eb9057b00a16195ee8960367.jpg";